/* global Sentry */

document.addEventListener('DOMContentLoaded', function () {
  const productHandle = new URLSearchParams(window.location.search).get(
    'product',
  );
  const trialContainer = document.getElementById('trial-container');
  const trialTitle = document.getElementById('trial-title');
  const trialCopy = document.getElementById('trial-copy');
  const screenshots = document.getElementsByClassName('screenshot');

  if (productHandle) {
    fetch(
      `${window.Shopify.routes.root}products/${productHandle}?view=trial-landing`,
    )
      .then((response) => {
        if (!response.ok) {
          window.location.href = '/404'; // productHandle doesn't match an existing product
        }
        return response.json();
      })
      .then((data) => {
        trialContainer.style.backgroundImage = `url(${data.backgroundURL})`;
        for (let i = 0; i < screenshots.length; i++) {
          screenshots[i].src = data.graphicURL;
          screenshots[i].alt = data.productTitle;
        }
        if (data.productPrice === '0') {
          trialTitle.textContent = `Download the Cradle Hub to get ${data.productTitle}!`;
          trialCopy.textContent = `Install the Cradle Hub and click on the Discover tab to get ${data.productTitle}!`;
        } else {
          trialTitle.textContent = `Download the Cradle Hub to start your free trial.`;
          trialCopy.textContent = `Install the Cradle Hub and click on the Discover tab to start your free trial`;
        }
      })
      .catch((error) => {
        Sentry.captureException(error);
      });
  } else {
    window.location.href = '/404'; // productHandle is empty
  }
});
